import NotFound from '@modules/error/component/not-found/NotFound';
import ErrorPageWrapper from '@modules/error/component/error-page-wrapper/ErrorPageWrapper';

const NotFoundPage = () => {
    return (
        <ErrorPageWrapper>
            <NotFound />
        </ErrorPageWrapper>
    );
};

export default NotFoundPage;
